export default __webpack_public_path__ + "static/media/photo--sm--blitz.4d8c0b8a.jpg";